export default "__VITE_ASSET__DHJfE$x6__"